define([
    './ElementsFinderByPath'
], function(ElementsFinderByPath) {
    var finder = new ElementsFinderByPath();
    var findByPath = finder.search.bind(finder);
    
    var findByCssSelector = function(selectors,findOne){
        /*
        selectors = selectors
                        .split(':').join('\\:')
                        .split('[').join('\\[')
                        .split(']').join('\\]')
                        .split('(').join('\\(')
                        .split(')').join('\\)')
                        .split('%').join('\\%')
                        .split('~').join('\\~')
                        .split('!').join('\\!');
                        */
        if (findOne){
            return [document.querySelector(selectors)];
        }
        
        var elementList = document.querySelectorAll(selectors);
        var result = [];
        for(var i = 0; i < elementList.length; i++){
            result.push(elementList.item(i));
        }
        return result
    
    }
    
    var findElement = function(pathOrSelector){
        return findElements(pathOrSelector,true);
    }
    var findElements = function(pathOrSelector,findOne){
        var result,
            isCssSelector = pathOrSelector.indexOf("/") == -1;
        if(isCssSelector){
            try{
                result = findByCssSelector(pathOrSelector,findOne);
            }
            catch(e){
                isCssSelector = false;
            }                  
        };
        if(!isCssSelector){
            try{
                result = findByPath(pathOrSelector,findOne);
            }
            catch(e){
                
            }
        }

        return result;
    };
    return findElements;
});


//////////////////
// WEBPACK FOOTER
// ./utils/findElements.js
// module id = 4
// module chunks = 0